
















































import Vue from "vue";
import { gameStore } from "../store/game/store";
import {
  getCardFilename,
  questionAsSentence,
  getInformantCardLetter,
  getCardName
} from "../functions";
import _ from "lodash";
export default Vue.extend({
  computed: {
    visible(): boolean {
      return (
        !!this.witnessResponse ||
        !!this.informantResponse ||
        !!this.accuseReponse
      );
    },
    witnessResponse() {
      const wi = gameStore.state.witnessInfo;
      if (!wi) return;
      const witness = _.find(gameStore.state.players, p => p.id == wi.witnessId)
        ?.name;
      return {
        question: `Hai chiesto a ${witness} ${questionAsSentence(wi.question)}`,
        answer: `${witness} risponde: ${wi.matchingCardsCount}`
      };
    },
    informantResponse() {
      const ic = gameStore.state.informantCard?.informantCard;
      if (!ic) return;
      return {
        letter: getInformantCardLetter(
          gameStore.state.informantCard!.cardIndex
        ),
        src: getCardFilename(ic)
      };
    },
    accuseReponse() {
      const accuse = gameStore.state.accuse;
      if (!accuse) return;

      return {
        correct: accuse.correct,
        cards: _.map(accuse.cards, getCardName).join(", ")
      };
    },
    title(): string | undefined {
      if (this.witnessResponse) return this.witnessResponse.question;
      if (this.informantResponse)
        return `La carta ${this.informantResponse.letter} dell'informatore segreto è:`;
    }
  },
  methods: {
    dismiss() {
      gameStore.commitClearResponses();
    }
  }
});
